import React from 'react';

import { TPaymentMethod } from '@entities/widget-shop/model/types';
import { Flex } from '@shared/ui';

import { PaymentMethodItem } from '..';
import cls from '../../PaymentWidgetModal.module.css';

interface IPaymentMethods {
    paymentsMethods: TPaymentMethod[];
    activePaymentMethodType: TPaymentMethod['type'];
    onMethodPick: (type: TPaymentMethod['type']) => void;
}

export const PaymentMethods = ({
    paymentsMethods,
    activePaymentMethodType,
    onMethodPick,
}: IPaymentMethods) => (
    <Flex
        as="ul"
        gap="8px"
        align="stretch"
        justify="start"
        fullWidth
        className={cls.optionsGroupBlock}
    >
        {paymentsMethods?.map((paymentMethod) => (
            <PaymentMethodItem
                key={paymentMethod.type}
                name={paymentMethod.name}
                type={paymentMethod.type}
                activePaymentMethodType={activePaymentMethodType}
                onMethodPick={() => onMethodPick(paymentMethod?.type)}
                redirectLink={paymentMethod.redirectLink}
                icon={paymentMethod.icon}
                activeIcon={paymentMethod.activeIcon}
            />
        ))}
    </Flex>
);
